import axios from "axios";
import appConfig from "@/config";
let BASE_URL = appConfig.api.base;
const STAGING_URL = appConfig.api.staging;

export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function login(
    email,
    password,
    freshRequest = false,
    otp = null,
    state = false
) {
    let url = "";
    if (state === true) url = `${STAGING_URL}/auth/token`;
    else url = `${BASE_URL}/auth/token`;

    return axios({
        method: "post",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: {
            grant_type: "password",
            client_id: "8232jn322",
            client_secret: "njskebdsej20u2323n",
            username: email,
            password: password,
            freshRequest: freshRequest,
            otp: otp
        }
    });
}
export function enable2fa(email, status, state = false) {
    let url = "";
    if (state === true) url = `${STAGING_URL}/merchant/twoFactor/update`;
    else url = `${BASE_URL}/merchant/twoFactor/update`;

    let accessToken = "";
    if (state === true) {
        accessToken = getCookie("staging_access_token");
    } else {
        accessToken = getCookie("token");
    }
    let merchantId = window.localStorage.getItem("merchantId");

    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            "merchant-id": merchantId
        },
        data: {
            grant_type: "password",
            client_id: "8232jn322",
            client_secret: "njskebdsej20u2323n",
            email,
            username: email,
            status: status
        }
    });
}

export function forgot(email) {
    const url = `${BASE_URL}/auth/password/forgot`;
    let link = "/resetPassword";
    return axios({
        method: "post",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: {
            email: email,
            url: link
        }
    });
}

export function reset(email, password, token) {
    const url = `${BASE_URL}/auth/password/reset`;
    return axios({
        method: "post",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: {
            email: email,
            password: password,
            token: token
        }
    });
}

//get token for first time user
export function getSignupToken(state = false) {
    let url = "";
    if (state === true) url = `${STAGING_URL}/auth/token`;
    else url = `${BASE_URL}/auth/token`;
    return axios({
        method: "post",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: {
            grant_type: "client_credentials",
            client_id: "8232jn322",
            client_secret: "njskebdsej20u2323n"
        }
    });
}

//register a first time user
export function registerUser(newUserObj, state = false){
  let url = '';
  let accessToken = '';
  if (state === true) {
    console.log('triggered staging reg 1', state);
    url = `${STAGING_URL}/auth/register`
    accessToken = getCookie('staging_access_token');
  } else {
    console.log('triggered prod reg 2', state);
    url = `${BASE_URL}/auth/register`
    accessToken = getCookie('access_token');
  }
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':accessToken
    },
    data: {
      name: newUserObj.fullName,
      email: newUserObj.email,
      city: newUserObj.city,
      state: newUserObj.state,
      address: newUserObj.address,
      phone_number: newUserObj.phoneNumber,
      password: newUserObj.password,
      originalPassword: newUserObj.originalPassword || null,
      merchant: {
        business_name:newUserObj.businessName,
        business_type:newUserObj.businessType,
        business_info:newUserObj.businessDescription,
      },
      currencies:newUserObj.currencies
    }
    });
}

export function logout(cb) {
    localStorage.removeItem("staging");
    document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "staging_access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "stagingToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "productionToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem("access_token");
    localStorage.removeItem("staging_access_token");
    localStorage.removeItem("productionToken");
    localStorage.removeItem("stagingToken");
    localStorage.removeItem("token");
    localStorage.removeItem("Search");
    localStorage.removeItem("TransactionsSearch");
    localStorage.removeItem("TerminalsSummary");
    localStorage.removeItem("TxnSummary");
    localStorage.removeItem("AgentSummary");
    localStorage.removeItem("AgentTxn");
    localStorage.removeItem("DispenseError");
    localStorage.removeItem("compliance");
    localStorage.removeItem("List");
    localStorage.removeItem("walletList");
    localStorage.removeItem("userFullDetails");
    localStorage.removeItem("posMerchant");
    localStorage.removeItem("signUpError");
    localStorage.removeItem("tempBal");
    cb();
}



// WEBPACK FOOTER //
// ./src/utils/auth/authService.js